import { useBienContext } from '../BienContext'

import ActivitiesList from '../../activities/ActivitiesList'

export default () => {
  const { bien } = useBienContext()

  return (
    <ActivitiesList bien={bien} />
  )
}